import ServerPassengerToBeDeletedFlightInterface from '../../interfaces/server/PassengerToBeDeletedFlight'

import constants from '../../config/constants'

import { dateToFrontEndFormat, dateToHoursFormat } from '../../utils/dates'

export const departureDate = ({
  departure,
}: ServerPassengerToBeDeletedFlightInterface) =>
  dateToFrontEndFormat(departure, constants.stdDateFormat)

export const departureTime = ({
  departure,
}: ServerPassengerToBeDeletedFlightInterface) =>
  dateToHoursFormat(departure, constants.stdDateFormat)

export default {
  origin: 'origin',
  destination: 'destination',
  departureDate,
  departureTime,
}
